import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import ProductCard from "@/components/ProductCard";
import { Link } from "react-router-dom";

export default function Wishlist() {
  const { items } = useWishlist();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    if (items.length === 0) return setProducts([]);
    api.get(`/products?limit=100`).then((r) => {
      setProducts(r.data.items.filter((p) => items.includes(p.id)));
    });
  }, [items]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
      <div className="eyebrow mb-2">Wishlist</div>
      <h1 className="font-serif text-3xl md:text-4xl text-[#0B1F3A] mb-8">Saved pieces</h1>
      {products.length === 0 ? (
        <div className="text-center py-16">
          <div className="text-[#1E293B]/60 mb-4">No pieces saved yet.</div>
          <Link to="/shop" className="bg-[#0B1F3A] text-[#FFF9E6] px-6 py-3 text-sm tracking-widest uppercase" data-testid="wish-shop">Start browsing</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">{products.map((p) => <ProductCard key={p.id} p={p} />)}</div>
      )}
    </div>
  );
}
